import { commerceFacetSetReducer as commerceFacetSet } from '../facet-set/facet-set-slice.js';
import { toggleSelectLocationFacetValue, } from './location-facet-actions.js';
/**
 * Loads the commerce facet set reducer and returns the available location facet action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the location facet action creators.
 */
export function loadLocationFacetActions(engine) {
    engine.addReducers({ commerceFacetSet });
    return {
        toggleSelectLocationFacetValue,
    };
}
